import { render, staticRenderFns } from "./datebox2.vue?vue&type=template&id=23fe70c6&"
import script from "./datebox2.vue?vue&type=script&lang=js&"
export * from "./datebox2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports